/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  ConsoleInstanceMatrixEnvironmentType,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION,
} from './types/ConsoleInstanceMatrixEnvironmentType.types';
import {
  ConsoleInstanceMatrixHostingType,
  CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_DEDICATED,
  CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_SAAS,
} from './types/ConsoleInstanceMatrixHostingType.types';

/**
 * All of the possible `CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_*`'s.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_HOSTING_TYPES: ReadonlyArray<ConsoleInstanceMatrixHostingType> = [
  CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_DEDICATED,
  CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_SAAS,
];

/**
 * All of the possible `CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPES*`'s.
 * @export
 */
export const CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPES: ReadonlyArray<ConsoleInstanceMatrixEnvironmentType> = [
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY,
];
